<ng-template #header>
    <shared-vcard-for-wizzard [title]="(locationDetails$ | async)?.LocationFriendlyName">
        <shared-link [emphasis]="false" (onClick)="handleAddressClick($event)">{{locationAddress$ | async}}
        </shared-link>
    </shared-vcard-for-wizzard>
</ng-template>

<shared-modal-type-dynamic-height [header]="header" [minHeight]="minHeight" [modalData]="modalData" [size]="size"
    [center]="true" (onCloseClick)="handleCloseClick($event)" class="modal-for-location-open-hours">

    <div class="modal-for-location-open-hours__content">
        <shared-open-hours [openHours]="locationOpenHours$ | async"></shared-open-hours>
    </div>

    <div class="modal-for-location-open-hours__actions">
        <ng-template #twoColumnsLeft>
            <shared-btn *ngIf="modalData.params?.canNavigate" feel="secondary" [width]="'extended'" size="xlg"
                (onClick)="handleChangeLocationClick($event)" [ngStyle]="{ position: 'relative', top: '10px' }">
                Change location</shared-btn>
        </ng-template>

        <ng-template #twoColumnsRight>
            <shared-btn [width]="'extended'" size="xlg" (onClick)="handleViewMenuClick($event)" [ngStyle]="{ position: 'relative', top: '10px' }">view menu
            </shared-btn>
        </ng-template>

        <shared-two-columns [left]="twoColumnsLeft" [right]="twoColumnsRight"></shared-two-columns>
    </div>

</shared-modal-type-dynamic-height>
